import React from "react";

import useMediaQuery from "../../hooks/useMediaQuery";

function DesktopEmptyDiv({ styles }: { styles?: React.CSSProperties }) {
  const isDesktop = useMediaQuery(1010);

  if (!isDesktop) {
    return null;
  }

  return <div style={styles} />;
}

export default DesktopEmptyDiv;
